import { usePlan } from '~/app/plan-context'
import * as m from '~/paraglide/messages'
import { getLocale } from '~/paraglide/runtime.js'
import { cn } from '~/shared/lib/utils'

/** The day a cancelled plan runs out; nothing while the plan simply renews. */
export function PlanEndsNote({ className }: { className?: string }) {
  const { isCancelPending, pendingChange } = usePlan()
  if (!isCancelPending || !pendingChange) return null

  const date = new Intl.DateTimeFormat(getLocale(), {
    timeZone: 'Europe/Vienna',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(pendingChange.effectiveAt))

  return <p className={cn('font-medium text-brand text-xs', className)}>{m.planEndsOn({ date })}</p>
}
